import { CompanyRole } from '@domain/company';
import { Channel } from '@domain/eventTeam';
import { UserPermission } from '@domain/user';

export interface AuthTokenResponse {
  accessToken: string;
  refreshToken: string;
}

export interface AuthContextTeam {
  id: string;
  name: string;
  eventId: string;
  channels: Channel['channel'][];
}

export interface AuthContextResponse {
  user: {
    id: string;
    email: string;
    username: string;
    isSuperAdmin: boolean;
  };
  company: {
    id: string;
  };
  role: CompanyRole;
  permissions: UserPermission[];
  channels: Channel['channel'][];
  teams: AuthContextTeam[];
}

export const useGetTokenQueryKey = 'get-tokens';
